import { useWavesurfer } from '@wavesurfer/react';
import * as React from 'react';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { PauseCircleIcon, PlayCircleIcon } from 'tdesign-icons-react';
import Timeline from 'wavesurfer.js/dist/plugins/regions.esm.js';

import styles from './index.module.less';

const formatTime = (seconds: number) => [seconds / 60, seconds % 60]
  .map(v => `0${Math.floor(v)}`.slice(-2))
  .join(':');

/**
 * 音频可视化组件
 */
export const Wavesurfer: React.FC<{
  url: string;
  name?: string;
}> = (props) => {
  const { url, name } = props;
  const containerRef = useRef(null);

  useEffect(
    () => () => {
      wavesurfer?.destroy();
    },
    [],
  );

  const { wavesurfer, isPlaying, currentTime } = useWavesurfer({
    container: containerRef,
    height: 100,
    waveColor: '#3D3D3D',
    progressColor: '#699ef5',
    url,
    plugins: useMemo(() => [Timeline.create()], []),
  });

  const onPlayPause = useCallback(() => {
    if (wavesurfer) {
      wavesurfer.playPause();
    }
  }, [wavesurfer]);

  if (!url) {
    return null;
  }

  return (
    <>
      <div className={styles.title}>
        <div onClick={onPlayPause}>
          {isPlaying ? (
            <PauseCircleIcon size={20} />
          ) : (
            <PlayCircleIcon size={20} />
          )}
        </div>
        <div className={styles.name}>{name}</div>
      </div>
      <div ref={containerRef} style={{ width: '100%', height: '100%' }} />
      <div className={styles.control}>
        <div className={styles.time}>
          {formatTime(currentTime)} /{' '}
          {formatTime(Number(wavesurfer?.getDuration()))}
        </div>
      </div>
    </>
  );
};
